import { render, staticRenderFns } from "./i18n-select.vue?vue&type=template&id=8a996cac&scoped=true&"
import script from "./i18n-select.vue?vue&type=script&lang=js&"
export * from "./i18n-select.vue?vue&type=script&lang=js&"
import style0 from "./i18n-select.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./i18n-select.vue?vue&type=style&index=1&id=8a996cac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a996cac",
  null
  
)

export default component.exports
import {QSelect,QItem,QItemSection} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QSelect,QItem,QItemSection})
